import React from 'react';
import { withProps } from 'recompose';
import { useTranslations } from 'js/components/common/I18n';
import { statuses } from '../../constants';
import style from './index.scss';

export const StatusBadgeDumb = ({ label, className = '', badgeClassName }) =>
    <div className={`${style.container} ${className}`}>
        <div className={badgeClassName}>{label}</div>
    </div>;

export const StatusBadge = withProps(
    ({ status, view = 'onCard', classNames = {}, tKeyPrefix = '' }) => {
        const t = useTranslations();
        return {
            label: t(`${tKeyPrefix}${status}`),
            badgeClassName: [
                style.badge,
                classNames.badge,
                style[status],
                style[view]
            ].filter(Boolean).join(' ')
        };
    }
)(StatusBadgeDumb);

export const LeaderboardStatusBadge = withProps(
    ({ status: lbStatus }) => {
        let status;
        switch (lbStatus) {
            case statuses.PENDING_REVIEW:
                status = 'pendingReview';
                break;
            case statuses.CANCELLED:
                status = 'cancelledByAdmin';
                break;
            case statuses.COMPLETED:
                status = 'completed';
                break;
            case statuses.ACTIVE:
                status = 'active';
                break;
            case statuses.NOT_STARTED:
                status = 'notStarted';
                break;
            default:
                status = lbStatus.toLowerCase();
        }

        return {
            status,
            tKeyPrefix: 'playtech.mobile.system.pass-the-parcel.status.'
        };
    })(StatusBadge);

export default LeaderboardStatusBadge;
